var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3919 17.7595V27.5064H36.568C36.9969 27.5064 37.4079 27.6767 37.7111 27.9799C38.0141 28.283 38.1845 28.6941 38.1845 29.1227V38.013H1.81543V23.8792C1.81553 23.625 1.8756 23.3744 1.99075 23.1477C2.1059 22.9211 2.27289 22.7248 2.47815 22.5748L13.8218 16.4502C14.0631 16.2739 14.3485 16.1679 14.6464 16.1441C14.9443 16.1202 15.243 16.1794 15.5092 16.315C15.7755 16.4507 15.999 16.6575 16.1548 16.9125C16.3106 17.1675 16.3927 17.4607 16.3919 17.7595Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6134 27.463L32.5803 2.04907H26.4809L24.4478 27.463",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.781 11.0076H33.271",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21436 3.66452C10.2084 9.25976 13.006 -1.93071 20.0001 3.66452",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21436 10.0007C10.2084 15.5959 13.006 4.40547 20.0001 10.0007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 38.0131V31.9468",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.610e5b8089bc3116cc2c7e88f30258ac.svg";
export { ForwardRef as ReactComponent };